import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { RootStore } from "../Store";
import { OrgEditStore } from "./OrgEditStore";
import { OrgStore } from "./OrgStore";

export class OrgsStore {
  rootStore: RootStore;
  orgView: OrgStore;
  orgEdit: OrgEditStore;
  loading = false;

  filter: any = {
    page: 0,
    size: 20,
    communityId: undefined,
    keyword: "",
    period: [undefined, undefined],
  };

  sortedInfo = { columnKey: "name.keyword", order: "ascend" };

  data = {
    total: 0,
    items: [],
  };
  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }
  constructor(rootStore: RootStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
    this.rootStore = rootStore;
    this.orgView = new OrgStore(this);
    this.orgEdit = new OrgEditStore(this);
  }

  @action loadData(communityId) {
    this.filter.communityId = communityId;
    this.refresh();
  }

  @action onSearch(history) {
    const { size, keyword } = this.filter;
    const { columnKey: sortKey, order: sortOrder } = this.sortedInfo;
    const query = new URLSearchParams({ size, keyword, page: "0", sortKey, sortOrder });
    history.push({ search: query.toString() });
  }

  @action onPage(history, page, pageSize) {
    const { keyword } = this.filter;
    const { columnKey: sortKey, order: sortOrder } = this.sortedInfo;

    const params: any = { keyword, page: page - 1, size: pageSize, sortKey, sortOrder };
    const query = new URLSearchParams({ ...params });
    history.push({ search: query.toString() });
  }

  @action onSort(history, sorter) {
    const { size, page, keyword } = this.filter;
    const { columnKey: sortKey, order: sortOrder } = sorter;
    const query = new URLSearchParams({ size, keyword, page, sortKey, sortOrder });
    history.push({ search: query.toString() });
  }

  @action onLocation(location, communityId) {
    const params = new URLSearchParams(location.search);
    const columnKey = params.get("sortKey") || "name.keyword";
    const order = params.get("sortOrder") || "ascend";
    const keyword = params.get("keyword") || "";
    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "100");
    this.filter = { page, size, keyword, communityId };
    this.sortedInfo = { columnKey, order };
    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { communityId, keyword, page, size } = this.filter;

    const sorts = this.sortedInfo.order
      ? [{ field: this.sortedInfo.columnKey, order: this.sortedInfo.order === "descend" ? "desc" : "asc" }]
      : [];

    const filter: any = {
      communityId,
      page,
      size,
      keyword,
      sorts,
    };

    Api.org
      .orgs(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.orgs;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action
  active(id: string) {
    this.orgView.active(id);
  }
}
